const engravingInputRTS = document.querySelector(".product-page-engraving-input")
const standardSizeSelectorRTS = document.querySelector('[name="options[Ring Size]"]');
const mobileProductFormSubmitBtnRTS = document.querySelector(".mobile-sticky-button-content span");
const productFormSubmitBtnRTS = document.querySelectorAll(".product-form__submit span");

if (engravingInputRTS) {
    engravingInputRTS.addEventListener('input', function (event) {
        let selectedValue = standardSizeSelectorRTS.value
        let engravingValue = engravingInputRTS.value
        let field = event.currentTarget;

        field.value = field.value.toUpperCase();

        if ((selectedValue !== 'Select') && (engravingValue !== '')) {
            for (i = 0; i < productFormSubmitBtnRTS.length - 1; ++i ) {
                productFormSubmitBtnRTS[i].innerHTML = `<span>ADD TO CART + ENGRAVING</span>`;
            }
            
            mobileProductFormSubmitBtnRTS.innerHTML = `<span>ADD TO CART + ENGRAVING</span>`;
        } else if ((selectedValue !== 'Select') && (engravingValue === '')) {
            for (i = 0; i < productFormSubmitBtnRTS.length - 1; ++i) {
                productFormSubmitBtnRTS.innerHTML = `<span>ADD TO CART</span>`;
            }
            
            mobileProductFormSubmitBtnRTS.innerHTML = `<span>ADD TO CART</span>`;
        }
    })
}